import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { NewsroomComponent } from './components/newsroom/newsroom.component';
import { AgencyManagementComponent } from './components/solutions/agency-management.component';
import { DeveloperManagementComponent } from './components/solutions/developer-management.component';
import { StrataManagementComponent } from './components/solutions/strata-management.component';
import { RentalManagementComponent } from './components/solutions/rental-management.component';
import { TradeAssociationManagementComponent } from './components/solutions/trade-association.component';
import { Property2MatchComponent } from './components/solutions/property2match.component';
import { GlobalREComponent } from './components/solutions/global-re.component';
import { MoreSolutionsComponent } from './components/solutions/more-solutions.component';
import { CrmComponent } from './components/features/crm.component';
import { EMarketingComponent } from './components/features/emarketing.component';
import { ECommerceComponent } from './components/features/ecommerce.component';
import { TransactionManagementComponent } from './components/features/transaction-management.component';
import { FinancialToolsComponent } from './components/features/financial-tools.component';
import { CmsComponent } from './components/features/cms.component';
import { AboutUsComponent } from './components/company/about-us.component';
import { PartnerProgramComponent } from './components/company/partner-program.component';
import { CareersComponent } from './components/company/careers.component';
import { OurOfficesComponent } from './components/contact/our-offices.component';
import { BecomePartnerComponent } from './components/contact/become-partner.component';

const routes: Routes = [
  { path: "", component: HomeComponent, data: { title: "Home" } },
  { path: "news-room", component: NewsroomComponent, data: { title: "News Room" } },
  { path: "agency-management", component: AgencyManagementComponent, data: { title: "Agency Management" } },
  { path: "developer-management", component: DeveloperManagementComponent, data: { title: "Developer Management" } },
  { path: "strata-management", component: StrataManagementComponent, data: { title: "Strata Management" } },
  { path: "rental-management", component: RentalManagementComponent, data: { title: "Rental Management" } },
  { path: "trade-association", component: TradeAssociationManagementComponent, data: { title: "Trade Association Management" } },
  { path: "property2match", component: Property2MatchComponent, data: { title: "Property2Match" } },
  { path: "global-re", component: GlobalREComponent, data: { title: "GlobalRE" } },
  { path: "more-solutions", component: MoreSolutionsComponent, data: { title: "Others" } },
  { path: "crm", component: CrmComponent, data: { title: "CRM" } },
  { path: "emarketing", component: EMarketingComponent, data: { title: "eMarketing" } },
  { path: "ecommerce", component: ECommerceComponent, data: { title: "eCommerce" } },
  { path: "transaction-management", component: TransactionManagementComponent, data: { title: "Transaction Management" } },
  { path: "financial-tools", component: FinancialToolsComponent, data: { title: "Financial Tools" } },
  { path: "cms", component: CmsComponent, data: { title: "CMS" } },
  { path: "about-us", component: AboutUsComponent, data: { title: "About Us" } },
  { path: "partner-program", component: PartnerProgramComponent, data: { title: "Partner Program" } },
  { path: "careers", component: CareersComponent, data: { title: "Careers" } },
  { path: "our-offices", component: OurOfficesComponent, data: { title: "Our Offices" } },
  { path: "become-partner", component: BecomePartnerComponent, data: { title: "Become Partner" } },
  { path: "home", redirectTo: "/", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
